<page-heading [title]="(isNew ? 'integrations.webhookForm.titleNew' : 'integrations.webhookForm.titleEdit') | translate" [description]="
    (isNew
      ? 'integrations.webhookForm.descriptionNew'
      : 'integrations.webhookForm.descriptionEdit') | translate
  " [hasBreadcrumb]="true" [breadcrumb]="breadcrumb" />

@if (loadingContent) {
<content-loading-list />
}

<div class="card">
  <div class="card-body py-3">
    <div class="row g-2 align-items-center justify-content-between">
      <div class="col-12 col-lg-6">
        <div class="d-flex align-items-center gap-2">
          <span class="fw-semibold text-nowrap">{{ 'integrations.webhookForm.webhookUrlLabel' | translate }}</span>
          <span class="text-muted small text-truncate" style="min-width: 0; max-width: 100%"
            [attr.title]="webhookIntegrations?.url">
            {{ webhookIntegrations.url }}
          </span>

          <button type="button" class="btn btn-link p-0 ms-1" id="copyIcon" (click)="copyUrl()" [attr.aria-label]="'integrations.webhookForm.copyUrl' | translate"
            [title]="'integrations.webhookForm.copyUrl' | translate">
            <i class="bi bi-clipboard fs-5"></i>
          </button>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="d-flex align-items-center justify-content-lg-end mt-2 mt-lg-0 gap-3">
          @if(isAdmin()) {
          <div class="custom-switch col-8 col-md-6">
            <input type="checkbox" id="webhookStatus" data-switch="success" [(ngModel)]="isActive"
              (change)="toggleWebhookStatus()" />
            <label for="webhookStatus">
              <span>
                <p class="text-muted">
                  {{ (isActive ? 'integrations.webhookForm.webhookStatusPrefixActive' : 'integrations.webhookForm.webhookStatusPrefixInactive') | translate }}
                  <strong class="text-nowrap" [ngClass]="{
                      'text-success': isActive,
                      'text-dark': !isActive
                    }">
                    {{ (isActive ? 'integrations.webhookForm.webhookStatusWorking' : 'integrations.webhookForm.webhookStatusTestMode') | translate }}
                  </strong>
                </p>
              </span>
            </label>
          </div>
          }
          <button type="button" class="btn btn-primary text-nowrap col-auto" (click)="openTestModal()">
            <i class="mdi mdi-send me-1"></i>
            {{ 'integrations.webhookForm.testWebhook' | translate }}
          </button>
          <button type="button" class="btn btn-primary text-nowrap col-auto" (click)="copyContent()">
            {{ 'integrations.webhookForm.generateCurl' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card" [ngStyle]="{ opacity: isActive ? '0.2' : '1' }">
  <form [formGroup]="formGroup">
    <div class="row">
      <div class="col-xs-12">
        <div class="row">
          <div class="card-body">
            <div class="row">
              <div class="col-xs-12 col-xl-8 mb-3">
                <label class="form-label">{{ 'integrations.webhookForm.nameLabel' | translate }}</label>
                <input type="text" class="form-control" maxlength="100" formControlName="name"
                  [placeholder]="'integrations.webhookForm.namePlaceholder' | translate" required="isActive" />
                <field-error-component [field]="'name'" [label]="'integrations.fields.name' | translate" [formGroup]="formGroup" />
              </div>
              <div class="col-xs-12 col-xl-4 mb-3">
                <label class="form-label">{{ 'integrations.webhookForm.selectChannelLabel' | translate }}</label>
                <mat-select class="form-control" formControlName="channel" [placeholder]="'integrations.webhookForm.selectChannelPlaceholder' | translate"
                  required="isActive">
                  @for(channel of channels; track channel ) {
                  <mat-option [value]="channel._id" (click)="changeChannelDialog(channel._id)">
                    {{ channel.name }}
                  </mat-option>
                  }
                </mat-select>
                <field-error-component [field]="'channel'" [label]="'integrations.fields.model' | translate"
                  [formGroup]="formGroup"></field-error-component>
              </div>
            </div>
            @if(selectedChannel) {
            <div class="row">
              <div class="col-xs-12 col-lg-3 mb-3">
                <div class="card h-100">
                  <div class="card-body">
                    <div class="row">
                      <h4 class="text-dark mb-2">{{ 'integrations.webhookForm.requestsTitle' | translate }}</h4>
                      <p class="text-muted">
                        {{ 'integrations.webhookForm.requestsDescription' | translate }}
                      </p>
                      <div class="custom-switch col-12 mb-3">
                        <input type="checkbox" id="requestType" checked data-switch="success"
                          formControlName="requestType" />
                        <label for="requestType">
                          <span value="DEFAULT">{{ 'integrations.webhookForm.requestTypeDefault' | translate }}</span>
                        </label>
                      </div>
                      <div class="col-xs-12 mb-3">
                        <div class="d-flex align-items-center gap-2">
                          <mat-select class="form-control" formControlName="tags" [placeholder]="'integrations.webhookForm.selectPlaceholder' | translate"
                            required="isActive">
                            @for(request of webhooks; track $index ) {
                            <mat-option [value]="request._id" (click)="webhookRequestSelected($index)">
                              {{ $index + 1 }}
                            </mat-option>
                            }
                          </mat-select>

                          <div class="d-flex align-items-center">
                            <i class="me-2 mt-1 cursor-pointer" [ngClass]="
                                loading
                                  ? 'spinner-border'
                                  : 'bi bi-arrow-repeat fs-2'
                              " [ngStyle]="
                                loading
                                  ? { 'width.px': 18, 'height.px': 18 }
                                  : null
                              " role="status" aria-hidden="true" (click)="isActive ? null : getWebhookRequests()"></i>
                          </div>
                        </div>
                      </div>
                      @if(webhookRequests) {
                      <div class="col-12">
                        <div class="border rounded-3 p-2 overflow-auto">
                          @for (request of webhookRequests | keyvalue; track
                          $index) {
                          <div class="d-flex mb-2">
                            <span class="fw-bold text-dark me-1">{{ request.key | lowercase }}:</span>
                            <span class="text-break">{{ request.value }}</span>
                          </div>
                          }
                        </div>
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-lg-9">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="fw-bold text-dark" style="font-size: 20px">
                        {{ 'integrations.webhookForm.actionsTitle' | translate }}
                        <sup>
                          <small class="text-muted"> {{ items.length }}</small>
                        </sup>
                      </h4>
                      <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
                        <button type="button" class="btn btn-primary fw-bold dropdown-toggle"
                          [matMenuTriggerFor]="newActionsType" [disabled]="this.isActive">
                          {{ 'integrations.webhookForm.addNewActions' | translate }}
                        </button>
                        <mat-menu #newActionsType="matMenu">
                          @for (action of actionsType; track $index) {
                          <button mat-menu-item (click)="addComponent(action)">
                            {{ getActionTypeLabel(action) }}
                          </button>
                          }
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12">
                  @for(item of items.controls; track $index) {
                  @if (selectedChannel) {
                  <div class="form-group">
                    <webhook-integrations-item-component [itemForm]="getItemForm($index)" [index]="$index"
                      [channel]="selectedChannel" [webhookRequests]="webhookRequests"
                      [webhookIntegrations]="webhookIntegrations" (remove)="deleteComponent($event)"
                      [isActive]="isActive">
                    </webhook-integrations-item-component>
                  </div>
                  }
                  }
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </form>
  @if(selectedChannel) {
  <div class="row m-2">
    <div class="col-12 gap-2 d-flex justify-content-end pb-4">
      <button class="btn btn-outline-secondary" (click)="goBack()">
        {{ 'integrations.webhookForm.cancel' | translate }}
      </button>

      @if(isAdmin() && !isActive) {
      <button class="btn btn-primary" type="submit" (click)="save()">
        <!-- [disabled]="!formGroup.valid || loading" -->
        {{ !loading ? ((isNew ? 'integrations.webhookForm.save' : 'integrations.webhookForm.update') | translate) : "" }}
        @if (loading) {
        <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
        }
      </button>
      }
    </div>
  </div>
  }
</div>